export default __webpack_public_path__ + "static/media/chevron-up.ecf14888.svg";